import Cookies from 'js-cookie'

let expiresTime = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
let expiresHour = new Date(new Date().getTime() + 1 * 60 * 1000)

// 重新设置过期时间
const resetExpiresTime = () => {
  expiresTime = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
  expiresHour = new Date(new Date().getTime() + 1 * 60 * 1000)
}
// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey) || ''
export const setSidebarStatus = (sidebarStatus: string) =>
  Cookies.set(sidebarStatusKey, sidebarStatus)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey) || ''
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// User
const tokenKey = 'gd_token'
export const getToken = () => Cookies.get(tokenKey) || ''
export const setToken = (token: string) => {
  resetExpiresTime()
  Cookies.set(tokenKey, token, { expires: expiresTime })
}
export const removeToken = () => Cookies.remove(tokenKey)

// Username
const usernameKey = 'gd_username'
export const getUsername = () => Cookies.get(usernameKey) || ''
export const setUsername = (username: string) =>
  Cookies.set(usernameKey, username, { expires: expiresTime })
export const removeUsername = () => Cookies.remove(usernameKey)

// User display name
const displaynameKey = 'gd_displayname'
export const getDisplayName = () => Cookies.get(displaynameKey) || ''
export const setDisplayName = (displayname: string) =>
  Cookies.set(displaynameKey, displayname, { expires: expiresTime })
export const removeDisplayName = () => Cookies.remove(displaynameKey)

// User display name
const avatarKey = 'gd_avatar'
export const getAvatar = () => Cookies.get(avatarKey) || ''
export const setAvatar = (avatar: string) =>
  Cookies.set(avatarKey, avatar, { expires: expiresTime })
export const removeAvatar = () => Cookies.remove(avatarKey)

// User display name
const roleKey = 'gd_role'
export const getRole = () => Cookies.get(roleKey) || ''
export const setRole = (avatar: string) =>
  Cookies.set(roleKey, avatar, { expires: expiresTime })
export const removeRole = () => Cookies.remove(roleKey)

// 登录次数限制
const loginTimes = 'gd_times'
export const getLoginTimes = () => Cookies.get(loginTimes) || '0'
export const setLoginTimes = (times: string) =>
  Cookies.set(loginTimes, times, { expires: expiresHour })
export const removeLoginTimes = () => Cookies.remove(loginTimes)

// 当前用户所选择APP
const userCurrentApp = 'gd_user_appid'
export const getuserCurrentApp = () => Cookies.get(userCurrentApp) || ''
export const setuserCurrentApp = (appId: string) => {
  // resetExpiresTime()
  Cookies.set(userCurrentApp, appId, { expires: expiresTime })
}
export const removeuserCurrentApp = () => Cookies.remove(userCurrentApp)

// 当前用户所选APP名称
const userCurrentAppName = 'gd_app_name'
export const getuserCurrentAppName = () =>
  Cookies.get(userCurrentAppName) || ''
export const setuserCurrentAppName = (name: string) => {
  // resetExpiresTime()
  Cookies.set(userCurrentAppName, name, { expires: expiresTime })
}
export const removeuserCurrentAppName = () =>
  Cookies.remove(userCurrentAppName)

// 当前用户工号
const userWorkCode = 'gd_workcode'
export const getuserWorkCode = () => Cookies.get(userWorkCode) || ''
export const setuserWorkCode = (name: string) => {
  resetExpiresTime()
  Cookies.set(userWorkCode, name, { expires: expiresTime })
}
export const removeuserWorkCode = () => Cookies.remove(userWorkCode)

// 是否是单独入口
const isSingleEntry = 'gd_single_entry'
export const getIsSingleEntry = () => Cookies.get(isSingleEntry) || ''
export const setIsSingleEntry = (id: string) => {
  resetExpiresTime()
  Cookies.set(isSingleEntry, id, { expires: expiresTime })
}
export const removeIsSingleEntry = () => Cookies.remove(isSingleEntry)

// 临时appid
const tempAppid = 'gd_temp_appid'
export const getTempAppid = () => Cookies.get(tempAppid) || ''
export const setTempAppid = (id: string) => {
  resetExpiresTime()
  Cookies.set(tempAppid, id, { expires: expiresTime })
}
export const removeTempAppid = () => Cookies.remove(tempAppid)
